import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import {
    setFeaturesSetupDeletePopupOpened,
} from "../featuresActions";
import {
    getFilteredFeatures,
} from "../featuresFunctions";
import { deleteFeatures, loadFeaturesSetupFeatures } from "../featuresAsyncActions";
import { showQuoteSavedNotification } from "../../Generic/SuccessNotification";

const FeaturesSetupDeletePopup = (props) => {
    const { setFeaturesSetupDeletePopupOpened, featuresSetupDeletePopupOpened, selectedFeatures, intl, loadFeaturesSetupFeatures, catId, groupName, deleteFeatures } = props;

    if (!featuresSetupDeletePopupOpened) {
        return null
    }

    const closePopup = () => {
        setFeaturesSetupDeletePopupOpened(false);
    };

    const okClick = async () => {
        const featDefIds = selectedFeatures.map(feature => feature.featureDefinitionId);
        const deleted = await deleteFeatures(featDefIds, intl);
        if (deleted) {
            showQuoteSavedNotification("features.setup.footer.savedSuccess.title", "features.setup.footer.savedSuccess.message");
            loadFeaturesSetupFeatures(groupName, catId); 
        }
        closePopup();
    }

    return (
        <div className={"ui-popup"}>
            <button className="ui-popup-header__close" onClick={closePopup} />
            <div className="ui-popup__header">
                <span className="ui-popup__header-title">
                    Delete Features
                </span>
            </div>
            <div className="ui-popup-body ui-popup-body--large">
                <div>Are you sure you want to delete selected features?</div>
                <div className="delete-popup-items-list">
                    <ul className="ui-list">
                        {selectedFeatures.map(feature => {
                            return (
                                <li key={feature.featureDefinitionId}>
                                    <div className="delete-popup-item">
                                        <img src={feature.imageUrl}></img>
                                        <span>{feature.name}</span>
                                        <span>${feature.cost}</span>
                                    </div>
                                </li>)
                        })}
                    </ul>
                </div>
            </div>
            <div className="ui-popup-footer">
                <button className="ui-button5 ui-button5--wide text-uppercase ui-button5--blue" onClick={closePopup}>
                    <FormattedMessage id="messageBox.buttons.cancel" />
                </button>
                <button className="ui-button5 ui-button5--wide text-uppercase ui-button5--green" onClick={okClick}>
                    <FormattedMessage id="messageBox.buttons.ok" />
                </button>
            </div>
        </div>
    )
};

const mapStateToProps = (store) => {
    const { featuresSetupDeletePopupOpened, catId, groupName} = store.featuresSetupState;
    const selectedFeaturesOnly = getFilteredFeatures(store, true, true);

    return {
        featuresSetupDeletePopupOpened,
        selectedFeatures: selectedFeaturesOnly,
        catId,
        groupName
    };
};

const mapDispatchToProps = {
    setFeaturesSetupDeletePopupOpened,
    deleteFeatures,
    loadFeaturesSetupFeatures
};

export default injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(FeaturesSetupDeletePopup)
)
